export const DIALOG_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.DialogTemplate';
